


export const reg_phone_format=/(\d{3})\d{4}(\d{4})/
export const reg_phone=/^1[3|4|5|6|7|8|9][0-9]\d{8}$/
export const reg_password=/^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{8,20}$/
export const reg_idcard=/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
export const reg_email= /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
export const reg_number =/^\d+(\.\d{1,2})?$/
export const reg_chinese =/^[\u4e00-\u9fa5]{0,}$/
export const reg_eng =/^[A-Za-z]+$/
export const reg_qq =/[1-9][0-9]{4,8}/
export const reg_car=/^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/



export const isPassingValidator = (rule, value, callback)=>{
  if(!value){
    callback(new Error('请拖动滑块验证'))
  }else{
    callback()
  }
}

export default {
  password: {pattern:reg_password, message: '密码需要包含数字及字母且8-20个字符', trigger: ["change", "blur"]},
  phone: {pattern:reg_phone, message: '请输入正确的手机号', trigger: ["change", "blur"]},
  email: {pattern:reg_email, message: '请输入正确的邮箱', trigger: ["change", "blur"]},
  idCard: {pattern: reg_idcard, message: '请输入正确的身份证号', trigger: ["change", "blur"]},
  money:  { pattern: /(^[0-9]([0-9]{1,7})?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确格式,可保留两位小数,最大值为99999999.99' },
  decimal_number:  { pattern: /^([0-9][0-9]*)+(.[0-9]{1,8})?$/, message: '最少1位小数,最多8位小数' },
  number:  { pattern: /^[0-9]\d*$/, message: '请输入数字' },
  webUrl:  { pattern: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&=]*)/, message: '请输入正确的网址，必须包含http' },
  passing_validator: {validator: isPassingValidator, trigger: ["change", "blur"]},
}


export const checkRules = (pattern,value) => {
  return RegExp(pattern).test(value)
}
